
import React, { forwardRef, useImperativeHandle, useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import PropTypes from "prop-types";

const NewNozzle = forwardRef(({ formInstance }, ref) => {
    const [open, setOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const [options, setOptions] = useState([]);

    // Expose modal open/close methods to parent
    useImperativeHandle(ref, () => ({
        openModal: () => setOpen(true),
        closeModal: () => setOpen(false),
    }));

    // Generate static nozzle options
    useEffect(() => {
        const nozzleOptions = Array.from({ length: 25 }, (_, i) => {
            const num = String(i + 1).padStart(2, "0");
            const label = `NOZ NO ${num}`;
            return { label, value: label };
        });
        setOptions(nozzleOptions);
    }, []);


    // When user selects an option
    // const handleSelectChange = (value) => {
    //     setSelectedOption(value);

    //     if (!value || !formInstance?.current) return;

    //     const compIdField = formInstance.current.getComponent("compId");
    //     if (compIdField) {
    //         // const existingValues = compIdField.component.data.values || [];
    //         const existingValues = compIdField.selectOptions || [];

    //         console.log("these existing values", existingValues);
    //         // Check if already exists
    //         const alreadyExists = existingValues.some((item) => item.value === value);
    //         if (!alreadyExists) {
    //             console.log("not already exist");
    //             const newOption = { label: value, value };
    //             compIdField.component.data.values = [newOption, ...existingValues];
    //             compIdField.redraw(true);
    //         }

    //         // Optional: set selected value
    //         // compIdField.setValue(value);
    //     }
    // };
    const handleSelectChange = (value) => {
        setSelectedOption(value);

        if (!value || !formInstance?.current) return;

        const compIdField = formInstance.current.getComponent("compId");
        console.log("this is comp id field", compIdField);
        if (!compIdField) return;

        const newOption = { label: value, value };

        // 1) Existing lists
        const existingOptions = compIdField.selectOptions || [];
        const exists = existingOptions.some(opt => opt.value === value);

        // 2) Add option visually (ChoicesJS)
        if (!exists) {
            compIdField.addOption(newOption);
            compIdField.selectOptions = [newOption, ...existingOptions];
        }

        // ✅ 3) Update templateData so label resolves correctly
        compIdField.templateData = compIdField.templateData || {};
        compIdField.templateData[value] = { label: value };

        // ✅ 4) Persist to cached API result (so redraw does not wipe your change)
        if (Array.isArray(window.cachedNozDataResult)) {
            window.cachedNozDataResult = [
                newOption,
                ...window.cachedNozDataResult.filter(o => o.value !== value)
            ];
            window.cachedNozData = Promise.resolve(window.cachedNozDataResult);
        }

        // ✅ 5) Update selected items list (so value appears selected in UI)
        compIdField.selectItems = compIdField.selectItems || [];
        if (!compIdField.selectItems.some(opt => opt.value === value)) {
            compIdField.selectItems = [newOption, ...compIdField.selectItems];
        }

        // ✅ 6) Visually select it
        // if (typeof compIdField.setValue === "function") {
        //     compIdField.setValue(value, true);
        // }

        // ✅ 7) Force redraw
        if (typeof compIdField.redraw === "function") {
            compIdField.redraw(true);
        }

        console.log("Updated templateData:", compIdField.templateData);
        console.log("Updated selectOptions:", compIdField.selectOptions);
        console.log("Updated selectItems:", compIdField.selectItems);
    };



    const handleSave = () => {

        setOpen(false);
    };

    if (!open) return null;

    return (
        <Modal show={open} onHide={() => setOpen(false)} centered>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <Modal.Header closeButton>
                    <Modal.Title
                        style={{
                            fontSize: "17px",
                            fontWeight: 600,
                            lineHeight: 1.5,
                            textAlign: "center",
                        }}
                        className="d-flex align-items-center justify-content-center gap-2"
                    >
                        Select Nozzle
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form.Group controlId="selectNozzle" className="mb-3">
                        <Form.Label>Select Nozzle</Form.Label>
                        <Form.Select
                            value={selectedOption}
                            onChange={(e) => handleSelectChange(e.target.value)}
                        >
                            <option value="">-- Select --</option>
                            {options.map((opt, idx) => (
                                <option key={idx} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setOpen(false)}
                        style={{ flex: 1, fontWeight: 600 }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="info"
                        onClick={handleSave}
                        style={{ flex: 1, fontWeight: 600 }}
                        disabled={!selectedOption}
                    >
                        Save
                    </Button>
                </Modal.Footer>
            </div>
        </Modal>
    );
});

NewNozzle.displayName = "NewNozzle";

NewNozzle.propTypes = {
    formInstance: PropTypes.object.isRequired,
};

export default NewNozzle;
